import { render, staticRenderFns } from "./CheckoutPreview.vue?vue&type=template&id=b65286a6"
import script from "./CheckoutPreview.vue?vue&type=script&lang=js"
export * from "./CheckoutPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports